module.exports = __webpack_public_path__ + "img/average_monthly_balance.d17be96c.png";